import type { EditableGradingRubric } from '../editorTypes';
import { RubricEditor } from './RubricEditor';

interface AIUploadQuestionEditorProps {
  disabled?: boolean;
  gradingRubric: EditableGradingRubric | undefined;
  onChange: (gradingRubric: EditableGradingRubric) => void;
  validationError?: string;
}

export function AIUploadQuestionEditor({
  disabled = false,
  gradingRubric,
  onChange,
  validationError,
}: AIUploadQuestionEditorProps) {
  return (
    <RubricEditor
      disabled={disabled}
      onChange={onChange}
      rubric={gradingRubric}
      validationError={validationError}
    />
  );
}
